export const fontFamilySans = "'Work Sans', sans-serif";
export const fontSize14 = 13;
export const opacity6 = 0.6;
export const opacity7 = 0.7;
export const opacity8 = 0.8;
export const opacity9 = 0.9;
